import {
  setStore,
  getStore,
  removeStore
} from '@/util/store'
import website from '@/config/website'

const common = { // 公共配置
  state: {
    language: getStore({ name: 'language' }) || 'zh', // 语言
    isCollapse: false, // 收缩
    isFullScren: false, // 全屏
    isMenu: true, // 是否是menu？
    isShade: false, // 未用到
    screen: -1, // 屏幕宽等级 3大屏 2中屏 1小屏 0超小屏
    isLock: getStore({ name: 'isLock' }) || false, // 锁屏
    showTag: true, // 显示tag栏
    showDebug: true, // 显示错误日志
    showCollapse: true, // 显示收缩
    showSearch: true, // 显示搜索栏
    showLock: true, // 显示锁屏
    showFullScren: true, // 显示全屏
    showTheme: true, // 显示主题
    showMenu: true, // 显示顶部菜单
    showColor: false, // 显示颜色选择
    colorName: getStore({ name: 'colorName' }) || '#409EFF', // 换色颜色选择
    themeName: getStore({ name: 'themeName' }) || 'theme-default', // 主题名称
    lockPasswd: getStore({ name: 'lockPasswd' }) || '', // 锁屏密码
    website: website, // website配置
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
      setStore({
        name: 'language',
        content: state.language
      })
    },
    SET_SHADE: (state, active) => {
      state.isShade = active
    },
    SET_COLLAPSE: (state) => {
      state.isCollapse = !state.isCollapse
    },
    SET_FULLSCREN: (state) => {
      state.isFullScren = !state.isFullScren
    },
    SET_IS_MENU: (state, menu) => {
      state.isMenu = menu
    },
    SET_LOCK: (state) => {
      state.isLock = true
      setStore({
        name: 'isLock',
        content: state.isLock,
        type: 'session'
      })
    },
    SET_SCREEN: (state, width) => {
      let result = -1
      if (width >= 1200) {
        result = 3 // 大屏幕
      } else if (width >= 992) {
        result = 2 // 中屏幕
      } else if (width >= 768) {
        result = 1 // 小屏幕
      } else {
        result = 0 // 超小屏幕
      }
      state.screen = result
    },
    SET_COLOR_NAME: (state, colorName) => {
      state.colorName = colorName
      setStore({
        name: 'colorName',
        content: state.colorName,
      })
    },
    SET_THEME_NAME: (state, themeName) => {
      state.themeName = themeName
      setStore({
        name: 'themeName',
        content: state.themeName,
      })
    },
    SET_LOCK_PASSWD: (state, lockPasswd) => {
      state.lockPasswd = lockPasswd
      setStore({
        name: 'lockPasswd',
        content: state.lockPasswd,
        type: 'session'
      })
    },
    CLEAR_LOCK: (state) => {
      state.isLock = false
      state.lockPasswd = ''
      removeStore({
        name: 'lockPasswd',
        type: 'session'
      })
      removeStore({
        name: 'isLock',
        type: 'session'
      })
    },
  }
}
export default common
